import LanguageSwitch from './language-switch';
export default LanguageSwitch;